import {
    FC,
    SignalPropsHandler,
    ExtendProps,
    copyPointData,
    getTexture,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Text as PixiText, TextStyle, ITextStyle } from 'pixi.js';
import {$Sprite, SpriteProps, ExtendSpriteProps} from './Sprite';

export type TextProps = ExtendSpriteProps<{
    experimentalLetterSpacing?: boolean;
    nextLineHeightBehavior?: boolean;
    resolution?: number;
    style?: TextStyle | Partial<ITextStyle>;
    text?: string | number;
}, PixiText>;

const TEXT_PROPS_LIST = [ 'experimentalLetterSpacing', 'nextLineHeightBehavior', 'resolution', 'style', 'text'] as const;
const propsHandler = new SignalPropsHandler<TextProps, PixiText>()
    .propsToHandle(TEXT_PROPS_LIST)
    .setHandlerFor('anchor', (val, obj) => copyPointData(val, obj.anchor))
    .setHandlerFor('texture', (val, obj) => obj.texture = getTexture(val));

/**
 * Basic Pixi Text component wrapper.
 */
export const $Text: FC<TextProps> = (props) => {
    const instance = props.instance ??= new PixiText();
    const unsubscribe = propsHandler.apply(props, instance);

    instance.on('destroyed', unsubscribe);

    return $Sprite(props as SpriteProps);
};

// Helper types
export type ExtendTextPropsSimple<T> = T & TextProps;
export type ExtendTextProps<T> = ExtendProps<T, TextProps, PixiText>;
